import { createAction, createAsyncAction } from 'typesafe-actions'
import { AuditLogsItemDto, AuditLogsItemRequestDto, ILogsResponseDto } from '@sparling/financial-common'

export const {
  request: getAuditLogsRequest,
  success: getAuditLogsSuccess,
  failure: getAuditLogsFailure,
} = createAsyncAction('GET_AUDIT_LOGS_REQUEST', 'GET_AUDIT_LOGS_SUCCESS', 'GET_AUDIT_LOGS_FAILURE')<
  { id: string; client: 'user' | 'company' } & AuditLogsItemRequestDto,
  ILogsResponseDto<AuditLogsItemDto>,
  Error
>()

export const {
  request: getLogTypesRequest,
  success: getLogTypesSuccess,
  failure: getLogTypesFailure,
} = createAsyncAction('GET_LOG_TYPES_REQUEST', 'GET_LOG_TYPES_SUCCESS', 'GET_LOG_TYPES_FAILURE')<
  { id: string; client: 'user' | 'company' },
  Array<string>,
  Error
>()

export const resetAuditLogsFilters = createAction('RESET_AUDIT_LOGS_FILTERS')<undefined>()
